var L = require('leaflet');

(function ($) {
    "use strict";
    $(window).on('load',function(){
      if(jQuery('#map-interactive').length != 0){
        var tiles = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
      }),
      latlng = L.latLng(46.829853, -71.254028);
      var markersLayer = new L.LayerGroup();
  
      var map = L.map('map-interactive', {center: latlng, zoom: 10, layers: [tiles], minZoom: 4, maxZoom: 15, dragging: !L.Browser.mobile, tap: !L.Browser.mobile });
      markersLayer.addTo(map);
      
        //var biPin = L.icon({ iconUrl: "/wp-content/uploads/2023/05/logo.png", iconSize: [36, 26] });



       
        var lang = jQuery('html:first').attr('lang');
        var btn_text =  lang == 'en-US' ? 'Discover the distributor': 'Découvrir le distributor';

        jQuery.ajax({
          type: "post",
          dataType: "json",
          url: ElementorProFrontendConfig.ajaxurl,
          data: { action: "carteinteractive", nonce: ElementorProFrontendConfig.nonce},
          success: function (response) {
            var markerArray = []; //create new markers array
            $.each(response, function(i, item) {
              var htmlPopup = '<div class="wrapper-popup">'
              if(item.logo){
                htmlPopup += '<div class="img-popup"><img src="'+ item.logo +'"></div>';
              }
              htmlPopup += '<div class="contenu-popup"><h3>'+ item.nom+'</h3><p>'+ item.adresse +'</p><p>'+ item.telephone +'</p></div></div><div class="dissan-btn">';
              if(item.url){
                htmlPopup += '<a class="link-popup elementor-button-link elementor-button elementor-size-sm" target="_blank" href="'+ item.url +'">' + btn_text + '</a>';
              }
              var marker = L.marker([item.lat, item.lng], {title: item.nom,  /*icon: biPin*/ }).bindPopup(htmlPopup, {closeOnClick: false, autoClose: true, minWidth : 560});
              markersLayer.addLayer(marker);

              markerArray.push(marker); //add each markers to array
              if(i==response.length-1){//this is the case when all the markers would be added to array
                var group = L.featureGroup(markerArray); //add markers array to featureGroup
                var pad = L.Browser.mobile ? [40, 40] : [200, 200];
                if(L.Browser.mobile){
                  map.setView([item.lat, item.lng], 6);
                }
                else{
                  map.fitBounds(group.getBounds(), { padding: pad });
                }
                //map.fitBounds(group.getBounds(), { padding: pad });
                //map.fitBounds(group.getBounds());   
            }
            function markerOpen(id){
              for (var i in markerArray){
                var markerID = markerArray[i].options.title;
                if (markerID == id){
                    markerArray[i].openPopup();
                }
              }
            }
            jQuery(".wrapper-partenaires-liste h3").on('click',function(){
                markerOpen(jQuery(this).attr("id"));
                //window.scrollTo(0, jQuery("#map-interactive").offset().top);
            });
          });
        }
    });
  }
 });

})(jQuery);

jQuery(window).on('resize',function(){
  //console.log('hellooooo');
});

// Initialize the map
/** var map = L.map('map', {
  scrollWheelZoom: false
}); **/
